import api from '../api/client';

const send = async (appId, payload) => {
    const res = await api.post('/api/invitation/send', payload, { params: { app_id: appId } });
    return res?.data;
};

const accept = async (payload) => {
    const res = await api.post('/api/invitation/accept', payload);
    return res?.data;
};

const verify = async (token) => {
    const res = await api.get(`/api/invitation/verify/${token}`);
    return res?.data?.data;
};

const list = async (appId) => {
    const res = await api.get('/api/invitation/list', { params: { app_id: appId } });
    return res?.data?.data;
};

// Server-paged list for the Invitations data table. `query` = { page, limit, sort, dir, search, filter_* }.
const getPage = async (appId, query) => {
    const res = await api.get('/api/invitation/list', { params: { app_id: appId, ...query } });
    return res?.data?.data;
};

const revoke = async (invitationId) => {
    const res = await api.post('/api/invitation/revoke', { invitation_id: invitationId });
    return res?.data;
};

const bulkSend = async (appId, payload) => {
    const res = await api.post('/api/invitation/bulk-send', payload, { params: { app_id: appId } });
    return res?.data;
};

const invitationsService = { send, accept, verify, list, getPage, revoke, bulkSend };
export default invitationsService;
